/* eslint-disable max-len */
/* eslint-disable indent */
import '../App.css';
import React, { useState, useEffect } from 'react';
import NuvoApp from './NuvoApp';
import { Link } from 'react-router-dom';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { MESSAGE } from '../constants/Message';
import { useNavigate } from 'react-router-dom';
import { PAGES } from '../constants/Pages';
import { useQuery, gql } from '@apollo/client';
import Header from './Header';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { getMessage } from '../translations';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { qualityDataQry } from '../gql/qualityDataQry';
import { getUserFromLocalStorage } from '../component/utils/user';

function UploaderScreen() {
  const localUser = getUserFromLocalStorage();
  const organisationID = localUser.organizationId;
  const [showLoadingUnitSelectionPopup, setShowLoadingUnitSelectionPopup] =
    useState(false);
  const [showUnitSelectionPopup, setShowUnitSelectionPopup] = useState(false);
  const [userUnitData, setUserUnitData] = useState('');
  const [deviationType, setDeviationType] = useState('');
  const [loadingType, setLoadingType] = useState('');
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [qualityNameDropdownData, setQualityNameDropdownData] = useState([]);
  const [qualityNamesDropdownData, setQualityNamesDropdownData] = useState('');
  const navigate = useNavigate();
  const qualityData = useQuery(qualityDataQry);
  const fetchData = () => {
    const names =
      qualityData.data && qualityData.data?.qualities
        ? qualityData.data?.qualities?.map((quality) => ({
          label: quality?.name,
          alternativeMatches: [quality?.id],
          value: quality?.id,
          type: 'string',
        }))
        : '>>';

    setQualityNameDropdownData(names);
  };
  useEffect(() => {
    if (qualityData.data) {
      fetchData();
    }
  }, [qualityData.data]);

  const handleLoadingGoButtonClick = (e) => {
    e.preventDefault();

    const trimmedLoadingType = loadingType ? loadingType.trim() : '';
    const trimmedDeviationType = deviationType ? deviationType.trim() : '';
    const trimmedStartDate = startDate instanceof Date ? startDate.toISOString().trim() : (startDate || '').trim();


    if (organisationID && organisationID.startsWith('schupan_lotr_extr')) {
      if (!userUnitData || !trimmedLoadingType || !startDate) {
        setShowValidationMessage(true);
      } else {
        window.location.href = `/${PAGES.LOADINGFRMAPP}/${userUnitData}&${trimmedLoadingType}&${trimmedDeviationType}
        &${trimmedStartDate}`;
      }
    } else {
      if (!userUnitData || !trimmedLoadingType) {
        setShowValidationMessage(true);
      } else {
        window.location.href = `/${PAGES.LOADINGAPP}/${userUnitData}&${trimmedLoadingType}&${trimmedDeviationType}`;
      }
    }
  };

  const handleGoButtonClick = (e) => {
    e.preventDefault();

    const trimmedLoadingType = loadingType ? loadingType.trim() : '';
    const trimmedDeviationType = deviationType ? deviationType.trim() : '';
    const trimmedStartDate = startDate instanceof Date ? startDate.toISOString().trim() : (startDate || '').trim();

    if (organisationID && organisationID.startsWith('schupan_lotr_extr')) {
      if (!userUnitData || !trimmedLoadingType || !startDate) {
        setShowValidationMessage(true);
      } else {
        window.location.href = `/${PAGES.NUVOFRMAPP}/${userUnitData}&${trimmedLoadingType}&${trimmedDeviationType}
        &${trimmedStartDate}`;
      }
    } else {
      if (!userUnitData || !trimmedLoadingType) {
        setShowValidationMessage(true);
      } else {
        window.location.href = `/${PAGES.NUVOAPP}/${userUnitData}&${trimmedLoadingType}&${trimmedDeviationType}`;
      }
    }
  };

  const resetPopupFields = () => {
    setUserUnitData('');
    setLoadingType('');
    setDeviationType('');
    setQualityNamesDropdownData('');
    setShowValidationMessage(false);
  };
  useEffect(() => {
    if (!showUnitSelectionPopup) {
      resetPopupFields();
    }
  }, [showUnitSelectionPopup]);
  useEffect(() => {
    if (!showLoadingUnitSelectionPopup) {
      resetPopupFields();
    }
  }, [showLoadingUnitSelectionPopup]);

  return (
    <>
      <body>
        <Header />
        <section id='deliveries-section' className='active'>
          <div id='container12' className='container columns full screen'>
            <div className='wrapper'>
              <div
                className='main-inner'
                data-onvisible-trigger='1'
                data-reorder='1,0'
                data-reorder-breakpoint='medium'
                style={{ opacity: 1 }}
              >
                <div className='w-50'>
                  <div className='container12info'>
                    <h2 id='text29' className='style8'>
                      <span className='p'>
                        {getMessage('Upload container info')}
                      </span>
                    </h2>
                    <ul
                      id='buttons24'
                      className='style1 buttons'
                      style={{ opacity: 1 }}
                    >
                      <li>
                        <button
                          style={{ marginRight: '30px' }}
                          className='QuantityAddBtn button n01'
                          onClick={() => {
                            setShowLoadingUnitSelectionPopup(true);
                          }}
                        >
                          <LocalShippingIcon />
                          <RiArrowDropRightLine className='startIcon' />{' '}
                          {getMessage('Loading info')}
                        </button>
                        <button
                          className='QuantityAddBtn button n01'
                          onClick={() => {
                            setShowUnitSelectionPopup(true);
                          }}
                        >
                          {/* <DoneAllIcon />   */}
                          <svg
                            style={{ width: '25px', height: '25px', display: 'block', marginTop: '18px' }}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              // eslint-disable-next-line max-len
                              d="M18.0002 7L16.5902 5.59L10.2502 11.93L11.6602 13.34L18.0002 7ZM22.2402 5.59L11.6602 16.17L7.48016 12L6.07016 13.41L11.6602 19L23.6602 7L22.2402 5.59ZM0.410156 13.41L6.00016 19L7.41016 17.59L1.83016 12L0.410156 13.41Z"
                              fill="#4E3BEB"
                            />
                            <path
                              // eslint-disable-next-line max-len
                              d="M4.9987 2.91667V1.25H0.832031V8.75H9.16536V2.91667H4.9987ZM2.4987 7.91667H1.66536V7.08333H2.4987V7.91667ZM2.4987 6.25H1.66536V5.41667H2.4987V6.25ZM2.4987 4.58333H1.66536V3.75H2.4987V4.58333ZM2.4987 2.91667H1.66536V2.08333H2.4987V2.91667ZM4.16536 7.91667H3.33203V7.08333H4.16536V7.91667ZM4.16536 6.25H3.33203V5.41667H4.16536V6.25ZM4.16536 4.58333H3.33203V3.75H4.16536V4.58333ZM4.16536 2.91667H3.33203V2.08333H4.16536V2.91667ZM8.33203 7.91667H4.9987V7.08333H5.83203V6.25H4.9987V5.41667H5.83203V4.58333H4.9987V3.75H8.33203V7.91667ZM7.4987 4.58333H6.66536V5.41667H7.4987V4.58333ZM7.4987 6.25H6.66536V7.08333H7.4987V6.25Z"
                              fill="#4E3BEB"
                            />
                          </svg>
                          <RiArrowDropRightLine className='startIcon' />{' '}
                          {getMessage('Delivery info')}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='w-40'>
                  <div id='image06' className='image full'>
                    <span className='frame deferred'>
                      <img
                        src='https://julesai.com/assets/images/image06.png'
                        data-src='done'
                        alt=''
                        style={{ opacity: 1 }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
      {showLoadingUnitSelectionPopup ? (
        <div className='overlay-box'>
          <div className='popup'>
            <a
              className='close'
              onClick={() => {
                setShowLoadingUnitSelectionPopup(false);
              }}
            >
              <svg
                className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium'
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                data-testid='CloseIcon'
              >
                <path
                  d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
                ></path>
              </svg>
            </a>
            <div className='content'>
              <form id='simpleForm'>
                <div className='AddCategoryBody'>
                  {
                    (organisationID && organisationID.startsWith('schupan_lotr_extr')) ?
                      (
                        <h4>{getMessage('Volume unit, loading type & date of loading')}</h4>
                      ) : (
                        <h4>{getMessage('LOADING_UNIT')}</h4>
                      )
                  }
                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <Select
                      value={userUnitData}
                      onChange={(e) => setUserUnitData(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value={''}>
                        {getMessage('VOLUME_UNIT')}
                      </MenuItem>
                      <MenuItem value={'Kg'}>Kg</MenuItem>
                      <MenuItem value={'T'}>T</MenuItem>
                      <MenuItem value={'Lbs'}>Lbs</MenuItem>
                      <MenuItem value={'ST'}>ST</MenuItem>
                      <MenuItem value={'GT'}>GT</MenuItem>
                    </Select>
                  </FormControl>

                  {
                    (organisationID && organisationID.startsWith('schupan_lotr_extr')) ?
                      (
                        <FormControl
                          className='FormField'
                          sx={{ m: 1, minWidth: '47%' }}
                        >
                          <DatePicker
                            className="date-picker-custm"
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                          />
                        </FormControl>
                      ) : (
                        <></>
                      )
                  }
                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <Select
                      value={loadingType}
                      onChange={(e) => setLoadingType(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value={''}>
                        {getMessage('LOADING_TYPE')}
                      </MenuItem>
                      <MenuItem value={'MATERIAL'}>
                        {getMessage('MATERIAL')}
                      </MenuItem>
                      <MenuItem value={'ITEM'}>{getMessage('ITEM')}</MenuItem>
                    </Select>
                  </FormControl>
                  {loadingType === 'MATERIAL' && (
                    <FormControl
                      className='FormField'
                      sx={{ m: 1, minWidth: '47%' }}
                    >
                      <Select
                        value={deviationType}
                        onChange={(e) => setDeviationType(e.target.value)}
                        required
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={''}>
                          {getMessage('Select deviation type')}
                        </MenuItem>
                        <MenuItem value={'STERILE'}>Sterile</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  <div className='validationMsg'>
                    {
                      (organisationID && organisationID.startsWith('schupan_lotr_extr')) ?
                        (
                          showValidationMessage &&
                          (!userUnitData || !loadingType || !startDate) && (
                            <p className='errorMsg'>
                              {getMessage('POPUP_LOADING_VALIDATION')}
                            </p>
                          )
                        ) : (
                          showValidationMessage &&
                          (!userUnitData || !loadingType) && (
                            <p className='errorMsg'>
                              {getMessage('POPUP_LOADING_VALIDATION')}
                            </p>
                          )
                        )
                    }
                  </div>
                  <div className='btnSection'>
                    <Button
                      variant='contained'
                      onClick={handleLoadingGoButtonClick}
                    >
                      {getMessage('GO')}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : null}
      {showUnitSelectionPopup ? (
        <div className='overlay-box'>
          <div className='popup'>
            <a
              className='close'
              onClick={() => {
                setShowUnitSelectionPopup(false);
              }}
            >
              <svg
                className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium'
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                data-testid='CloseIcon'
              >
                <path
                  d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
                ></path>
              </svg>
            </a>
            <div className='content'>
              <form id='simpleForm'>
                <div className='AddCategoryBody'>
                  {
                    (organisationID && organisationID.startsWith('schupan_lotr_extr')) ?
                      (
                        <h4>{getMessage('Volume unit, loading type & date of delivery')}</h4>
                      ) : (
                        <h4>{getMessage('DELIVERY_UNIT')}</h4>
                      )
                  }

                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <Select
                      value={userUnitData}
                      onChange={(e) => setUserUnitData(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value={''}>
                        {getMessage('VOLUME_UNIT')}
                      </MenuItem>
                      <MenuItem value={'Kg'}>Kg</MenuItem>
                      <MenuItem value={'T'}>T</MenuItem>
                      <MenuItem value={'Lbs'}>Lbs</MenuItem>
                      <MenuItem value={'ST'}>ST</MenuItem>
                      <MenuItem value={'GT'}>GT</MenuItem>
                    </Select>
                  </FormControl>
                  {
                    (organisationID && organisationID.startsWith('schupan_lotr_extr')) ?
                      (
                        <FormControl
                          className='FormField'
                          sx={{ m: 1, minWidth: '47%' }}
                        >
                          <DatePicker
                            className="date-picker-custm"
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                          />
                        </FormControl>
                      ) : (
                        <></>
                      )
                  }
                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <Select
                      value={loadingType}
                      onChange={(e) => setLoadingType(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value={''}>
                        {getMessage('DELIVERY_TYPE')}
                      </MenuItem>
                      <MenuItem value={'MATERIAL'}>
                        {getMessage('MATERIAL')}
                      </MenuItem>
                      <MenuItem value={'ITEM'}>{getMessage('ITEM')}</MenuItem>
                    </Select>
                  </FormControl>
                  {loadingType === 'MATERIAL' && (
                    <FormControl
                      className='FormField'
                      sx={{ m: 1, minWidth: '47%' }}
                    >
                      <Select
                        value={deviationType}
                        onChange={(e) => setDeviationType(e.target.value)}
                        required
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={''}>
                          {getMessage('Select deviation type')}
                        </MenuItem>
                        <MenuItem value={'STERILE'}>Sterile</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  <div className='validationMsg'>
                    {showValidationMessage &&
                      (!userUnitData || !loadingType) && (
                        <p className='errorMsg'>
                          {getMessage('POPUP_LOADING_VALIDATION')}
                        </p>
                      )}
                  </div>
                  <div className='btnSection'>
                    <Button variant='contained' onClick={handleGoButtonClick}>
                      {getMessage('GO')}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default UploaderScreen;
